import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface FormContextProps {
    updateCurrentSection: (index: number) => void;
    currentSection: number | null;
}

const FormContext = createContext<FormContextProps | undefined>(undefined);

export const FormProvider: React.FC<{ children: ReactNode }> = ({ children }) => {

    const [currentSection, setCurrentSection] = useState<number | null>(null);

    const updateCurrentSection = (index: number) => {
        setCurrentSection(index);
    }

    return (
        <FormContext.Provider value={{ currentSection, updateCurrentSection }}>
            {children}
        </FormContext.Provider>
    );
};
export const useFormContext = () => {
    const context = useContext(FormContext);
    if (!context) {
        throw new Error('useFormContext must be used within a FormProvider');
    }
    return context;
};
